// extracted by mini-css-extract-plugin
export default {"name":"cx_j9","price":"cx_kj","items":"cx_kk","hidden":"cx_kl","item":"cx_gk","check":"cx_km","toggleButton":"cx_kn","arrowIcon":"cx_gP","isOpen":"cx_kp"};